import { render, staticRenderFns } from "./take-out-food.vue?vue&type=template&id=2bc1b4cd&"
import script from "./take-out-food.vue?vue&type=script&lang=js&"
export * from "./take-out-food.vue?vue&type=script&lang=js&"
import style0 from "./take-out-food.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports